module.exports = __webpack_public_path__ + "img/7.62bb13b4.png";